// extracted by mini-css-extract-plugin
module.exports = {"conteiner":"ReportRSOPage_conteiner__1zRyW","customConfirmModalRso":"ReportRSOPage_customConfirmModalRso__CQj5r"};